/* یک ستون، دو معنا: `national_code` برای شخص حقیقی «کد ملی» است و برای شخص
 * حقوقی «شناسه ملی» — هر دو ده‌رقمی‌اند و ستون تازه‌ای لازم ندارند. */
export const CUSTOMER_TYPES = {
  individual: { label: "شخص حقیقی", identity: "کد ملی" },
  company: { label: "شخص حقوقی", identity: "شناسه ملی" },
};

/* چهار حالت به‌علاوه‌ی «از دست رفته» — نه یک قیف فروش با پیش‌بینی درآمد، فقط
 * همان‌قدر که لیست مشتریان را از دفترچه‌تلفن به چیزی قابل‌تصمیم‌گیری تبدیل کند. */
export const CUSTOMER_STATUSES = {
  lead: { label: "سرنخ", color: "default" },
  negotiation: { label: "در مذاکره", color: "gold" },
  active: { label: "فعال", color: "green" },
  idle: { label: "راکد", color: "orange" },
  lost: { label: "از دست رفته", color: "red" },
};

export const CUSTOMER_TYPE_OPTIONS = Object.entries(CUSTOMER_TYPES).map(
  ([value, item]) => ({ value, label: item.label }),
);

export const CUSTOMER_STATUS_OPTIONS = Object.entries(CUSTOMER_STATUSES).map(
  ([value, item]) => ({ value, label: item.label }),
);

export const identityLabel = (type) =>
  CUSTOMER_TYPES[type]?.identity || CUSTOMER_TYPES.individual.identity;

/* وضعیت تیکت مشتری. چهار حالت است، نه یک SLA کامل: تسکامون میز پشتیبانی نیست،
 * فقط باید بداند چه درخواستی هنوز جواب نگرفته. */
export const TICKET_STATUSES = {
  open: { label: "باز", color: "gold" },
  in_progress: { label: "در حال بررسی", color: "blue" },
  answered: { label: "پاسخ داده شد", color: "green" },
  closed: { label: "بسته شده", color: "default" },
};

export const TICKET_PRIORITIES = {
  low: { label: "کم", color: "default" },
  normal: { label: "عادی", color: "blue" },
  high: { label: "زیاد", color: "orange" },
  urgent: { label: "فوری", color: "red" },
};

export const TICKET_STATUS_OPTIONS = Object.entries(TICKET_STATUSES).map(
  ([value, item]) => ({ value, label: item.label }),
);

export const TICKET_PRIORITY_OPTIONS = Object.entries(TICKET_PRIORITIES).map(
  ([value, item]) => ({ value, label: item.label }),
);
